"use client";

import React, { useState } from "react";

import axios from "axios";
import getStripe from "./getStripe";
import { STIPE_PACKAGE_IDS, STRIPE_PACKAGES } from "./constants";
import { Button } from "@material-tailwind/react";
import RegisterModal from "../Modal/Register";
import { sendAnalyticsEvent } from "@/src/utils/analytics";
import { TEST_STRIPE } from "@/src/constants";
export interface CheckoutFormProps {
  packageType?: "BBL" | "NRL" | "FULL";
  userId: string;
  packageId?: string;
  price?: string;
  description?: string;
  priceId?: string;
  purchaseType?: string;
}

export default function CheckoutForm({
  packageType = "FULL",
  userId = "",
  packageId,
  price,
  description,
  priceId,
  purchaseType = "subscription",
}: CheckoutFormProps): JSX.Element {
  const [loading, setLoading] = useState<boolean>(false);
  const [showRegisterDialog, setShowRegisterDialog] = useState(false);
  const [newUserEmail, setNewUserEmail] = useState("");

  const fireCheckout = async (uId: string) => {
    setLoading(true);
    const response = await axios
      .post("/api/checkout_sessions", {
        amount: 10,
        productId: packageId
          ? packageId
          : STIPE_PACKAGE_IDS[TEST_STRIPE]["packages"][packageType][
              "productId"
            ],
        price: priceId
          ? priceId
          : STIPE_PACKAGE_IDS[TEST_STRIPE]["packages"][packageType]["price"],
        userId: uId,
        purchaseType: purchaseType,
      })
      .catch((e) => {
        console.log("error checkoutform", e);
        setShowRegisterDialog(true);
      });

    const stripe = await getStripe();

    const { error } = await stripe!.redirectToCheckout({
      // Make the id field from the Checkout Session creation API response
      // available to this file, so you can provide it as parameter here
      // instead of the {{CHECKOUT_SESSION_ID}} placeholder.

      //@ts-ignore
      sessionId: response?.data?.id,
    });
    if (error) {
      console.log("Error: ", error);
      setShowRegisterDialog(true);
      setLoading(false);
    }
    // setLoading(false);
  };

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault();
    setLoading(true);
    sendAnalyticsEvent({
      type: "click_subscribe_button",
      value: userId ? `user-${userId}` : "unknown user",
    });
    let theUserId = userId;
    if (!userId || userId === "") {
      setShowRegisterDialog(true);
    } else {
      await fireCheckout(theUserId);
    }
  };

  return (
    <>
      {showRegisterDialog && (
        <RegisterModal
          open={showRegisterDialog}
          setOpen={(open: boolean) => {
            setShowRegisterDialog(open);
            // setLoading(false);
          }}
          onClose={() => {
            setShowRegisterDialog(false);
          }}
          onComplete={(id: string, email: string) => {
            sendAnalyticsEvent({
              type: "user_register",
              value: `${id}, ${email}`,
            });
            fireCheckout(id);
            setNewUserEmail(email);
          }}
        />
      )}
      <form onSubmit={handleSubmit} className="w-full">
        <Button
          className={`purchase-button bg-scpb-light-blue w-[100%]`}
          variant="gradient"
          color={"light-blue"}
          type="submit"
          disabled={loading}
        >
          {description ? description : "Subscribe"}
        </Button>
      </form>
    </>
  );
}
